























import { defineComponent, toRef, watch } from '@vue/composition-api';
import useFakeProgress from '@berlin-front/common/composables/useFakeProgress';
import AppProgressBar from '@berlin-front/common/components/elements/AppProgressBar';
import AppText from '@berlin-front/common/components/elements/AppText';

export default defineComponent({
  name: 'WaitForLoading',
  components: { AppProgressBar, AppText },

  props: {
    /**
     * 見せかけの完了までの時間
     * 単位はms秒（1s = 1000ms）
     */
    completeDuration: {
      type: Number,
      default: 2000,
    },

    /**
     * 完了したか否か
     */
    completed: {
      type: Boolean,
      default: false,
    },

    /**
     * ローディング中か否か
     */
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  emits: [
    /**
     * プログレスバーの見た目の進捗が100%になったら呼び出される
     */
    'complete',
  ],

  setup(props, context) {
    const isLoading = toRef(props, 'isLoading');
    const processCompleted = toRef(props, 'completed');
    const fakeProgress = useFakeProgress(props.completeDuration, isLoading, processCompleted);
    const progressCompleted = toRef(fakeProgress, 'completed');
    watch(progressCompleted, (value) => {
      if (value) context.emit('complete');
    });
    return {
      fakeProgress,
    };
  },
});
